<template>
<div class="footer">
  <div class="firstLine">
    <div class="footerTop">
      <div class="left">
        <div class="col">
          <h3>Explore</h3>
          <router-link :to="navTo('/Features')"><p>Features</p></router-link>
          <router-link :to="navTo('/Pricing')"><p>Pricing</p></router-link>
          <router-link :to="navTo('/AboutUs')"><p>About Us</p></router-link>
          <router-link :to="navTo('/Arcanite')"><p>Arcanite</p></router-link>
          <router-link :to="navTo('/ArcaniteConnect')"><p>Arcanite Connect</p></router-link>
          <router-link :to="navTo('/ArcanitePartners')"><p>Arcanite Partners</p></router-link>
          <router-link :to="navTo('/DragonVR')"><p>DragonVR</p></router-link>
          <!-- <p  @click="goRouter('/Equimate')">Equimate</p> -->
          <router-link :to="navTo('/Marketplace')"><p>Marketplace</p></router-link>
        </div>
        <div class="col">
          <h3>Resources</h3>
          <router-link :to="navTo('/Blogs')"><p>Blogs</p></router-link>
          <a href="https://apps.apple.com/au/app/arc-agent/id1510107896" target="_blank">
            <p>Agent App (iPhone)</p>
          </a>
          <a href="https://play.google.com/store/apps/details?id=au.com.arcnet.agent " target="_blank">
          <p>Agent App (Android)</p>
          </a>
		  <a href="https://apps.apple.com/au/app/arcanite-connect/id1598271065" target="_blank">
		  <p>Admin App (iPhone)</p>
		  </a>
		  <a href="https://play.google.com/store/apps/details?id=au.com.arcnet.admin" target="_blank">
		  <p>Admin App (Android)</p>
		  </a>
          <a href="https://agent.arcnet.com.au/" target="_blank">
          <p>Agent Web Login</p>
          </a>
          <a href="https://agency.arcnet.com.au/" target="_blank">
          <p>Admin Web Login</p>
          </a>
          <a href="https://partner.arcnet.com.au/" target="_blank"> 
          <p>Partner Portal Login</p>
          </a>
        </div>
        <div class="col">
          <h3>Contact</h3>
          <!-- <a href="" -->
          <a href="mailto:support@arcnet.com.au">
          <p>support@arcnet.com.au</p>
          </a>
          <p>66 Berry St, <br/>North Sydney NSW 2060 <br/>Australia</p>
        </div>
      </div>
      <div class="right">
        <h3>
          Ready to  get started?
        </h3>
        <!-- <div v-if="!isID" class="btn">
          <a onclick="Calendly.showPopupWidget('https://meetings.hubspot.com/william463?embed=true');return false;">
          <button class="btnA" :class="[isID?'IDbtnA':'']"><span class="text">{{ $t("pricing.book_a_demo") }}&nbsp;&nbsp;&nbsp;</span><img src="./../../assets/imgs/pc/footer/arrorRight.png" class="arrow"/></button>
          </a>
        </div>
        <div v-else class="btn">
          <a onclick="Calendly.showPopupWidget('https://calendly.com/erni-yap');return false;">
          <button class="btnA" :class="[isID?'IDbtnA':'']"><span class="text">{{ $t("pricing.book_a_demo") }}&nbsp;&nbsp;&nbsp;</span><img src="./../../assets/imgs/pc/footer/arrorRight.png" class="arrow"/></button>
          </a>
        </div> -->
        <div class="btn">
          <el-button  v-if="!isID" class="btnA" :class="[isID?'IDbtnA':'']"><span class="text" @click.stop="handleDemoBooking(true)">{{ $t("home.free_demo") }}<img src="./../../assets/imgs/pc/footer/arrorRight.png" class="arrow"></span></el-button>
          <el-button  v-else class="btnA" :class="[isID?'IDbtnA':'']"><span class="text"  @click.stop="handleDemoBooking(true)">{{ $t("home.free_demo") }}<img src="./../../assets/imgs/pc/footer/arrorRight.png" class="arrow"></span></el-button>
        </div>
        <h3>Follow Us</h3>
        <div class="icons">
          <a href="https://www.linkedin.com/company/arcanite-au/" target="_blank"><img src="./../../assets/imgs/pc/footer/linkin.png" alt="Arcanite on LinkedIn" /></a>
          <a href="https://www.instagram.com/arcanite.au/" target="_blank"><img src="./../../assets/imgs/pc/footer/ins.png" alt="Arcanite on Instagram" /></a>
          <a href="https://www.facebook.com/arcanite.au/" target="_blank"><img src="./../../assets/imgs/pc/footer/facebook.png" alt="Arcanite on Facebook" /></a>
          <a href="https://x.com/Arcanite_au" target="_blank"><img src="./../../assets/imgs/pc/footer/twitter.png" alt="Arcanite on X" /></a>
        </div>
        <h3>Country</h3>
        <div class="icons">
          <div class="ImgSpace" v-if="value=='au'"><img class="countryImgOutSide" style="margin:0;" src="./../../assets/imgs/pc/footer/australia.png"/></div>
          <div class="ImgSpace" v-if="value=='id'"><img class="countryImgOutSide" style="margin:0;" src="./../../assets/imgs/pc/footer/indonesia.png"/></div>
          <el-select class="selectStyle" v-model="value" @change="changeLanguage">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
              <div class="countryOptions">
                <div v-if="item.value=='au'"><img class="countryImg" src="./../../assets/imgs/pc/footer/australia.png"/></div>
                <div v-if="item.value=='id'"><img class="countryImg" src="./../../assets/imgs/pc/footer/indonesia.png"/></div>
                <div class="countryOptionsText">{{item.label}}</div>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>   
  </div>
   <book-demo v-if="showBookingDialog" :show="showBookingDialog" @update:show="handleDemoBooking"></book-demo>
  <div class="secondLine">
    <div class="footBottom">
      <div class="middle">
        <img src="./../../assets/imgs/pc/footer/icon1.png" class="icon1" alt="Arcanite"/>
        <p>© {{ currentYear }} Arcanite</p>
        <router-link :to="navTo('/PrivacyPolicy')"><p>Privacy Policy</p></router-link>
        <router-link :to="navTo('/TermsAndConditions')"><p>Terms & Conditions</p></router-link>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { replaceUrl } from "@/assets/js/utility.js";

export default {
  data(){
    return {
      isID:false,
      userId: '',
      name: "",
      email: "",
      value: 'au',
      options: [{
        value: 'au',
        label: 'AU'
      }, {
        value: 'id',
        label: 'ID',
        // disabled: true
      }],
      showBookingDialog: false,
      currentYear: new Date().getFullYear()
    }
  },
  created(){
    if(localStorage.getItem('country')=="id"){
      this.isID=true;
    }else{
      this.isID=false;
    }
    // wwjw
    // console.log("window.location",window.location.host)
    this.value = localStorage.getItem('country') || 'au'
    // this.value = "au"
    // this.userId='arcweb'+ new Date().getTime() + this.MathRand();
  },
  mounted() {
    // this.$intercom.boot({
    //   app_id: "uu6ddns6",
    //   user_id: this.userId,
    //   name: this.name,
    //   email: this.email
    // });
  },
  watch: {
    // email(email) {
    //   this.$intercom.update({ email });
    // }
  },
  methods:{     
    handleDemoBooking(open = false) {
      const rawpath = this.$route.path;
      const base = rawpath === '/' ? '' : rawpath.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      if (open) {
        history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      } else {
        history.replaceState({}, '', base || '/');
      }
      this.showBookingDialog = open;
    },
    changeLanguage(){
      let country = localStorage.getItem('country')
      let url;
      let host = window.location.host;

      if(this.value == country){
        return;
      }else if((this.value != country) && this.value == "au"){
        sessionStorage.setItem('doubleCheckID','0')
        if(host.indexOf('staging')>-1){
            let auhost = host.split('arcanite.id')
            url = auhost[0].concat('arcnet.com.au');
        } else{
            url = replaceUrl(host, 'au');
        }
        let path = window.location.protocol + '//' + url
        if(window.location.href.indexOf('http://localhost')>-1){
          var testurl = 'localhost:8080/'
          window.location.href = window.location.protocol + '//' + testurl
        }else{
          window.location.href = path
        }
        localStorage.setItem('country','au')
        
      }else if((this.value != country) && this.value == "id"){
        sessionStorage.setItem('doubleCheckID','1')
        let idhost
        if(host.indexOf('staging')>-1){
          idhost = host.split('arcnet.com.au')
          url = idhost[0].concat('arcanite.id')
        }else{
          url = replaceUrl(host, 'id');
        }
        let path = window.location.protocol + '//' + url
        // window.HubSpotConversations.widget.remove(); 
        if(window.location.href.indexOf('http://localhost')>-1){
          var testurl = 'localhost:8080/'
          window.location.href = window.location.protocol + '//' + testurl
        }else{
          window.location.href = path
        }
        localStorage.setItem('country','id')
      }
    },
    goRouter(path){
      const socialmedia = localStorage.getItem('socialmedia');
      const newPath = path + (socialmedia != '' ? `/${socialmedia}` : '/');
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
    },
    navTo(path) {
      const socialmedia = localStorage.getItem('socialmedia');
      return path + (socialmedia != '' ? `/${socialmedia}` : '/');
    },
    // handleBookBtn() {
    //   this.$intercom.show();
    // },
    MathRand(){
      var Num="";
      for(var i=0;i<6;i++)
      {
      Num+=Math.floor(Math.random()*10);
      }
      return Num
    }, 
    handleClose(){
      // this.isShow=false
      this.$emit('changeIsShow')
    }
  },  
  components: {
    "book-demo": () => import("./BookDemo/Index.vue")
  },
 
}
</script>
<style lang="scss" scoped>
  .footer{
    position: relative;
    // overflow-x:hidden;
    .firstLine{
      background-color: #FFFFFF;
      width:100vw;
      display: inline-block;
      text-align: center;
      min-height: 563px;
      .footerTop {
        margin:auto;
        width: 1210px;
        // padding: 0 35px 0 35px;
        // margin: 125.9px 0 95px;
        // padding: 40.6px 648px 51.5px 608px;
        display: flex;
        padding-top: 80.1px;
        .left{
          // width: 934px;
          height: 100%;
          display: flex;
          .col{
            margin:0 10px 0 0;
            width: 276.7px;
            text-align: left;
            h3{
              // margin: 91px 10px 30px 247px;
              margin:10px;
              font-family: Poppins-Bold;
              font-size: 16px;
              // font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.38;
              letter-spacing: normal;
              text-align: left;
              color: #062440;
              display: inline-block;
              padding: 10px;
            }
            p{
              margin-left: 10px;
              flex-grow: 0;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: flex-start;
              // gap: 10px;
              padding: 10px;
              font-family: Poppins;
              color: #67788C;;
              font-size: 14px;
              line-height: 1.43;
            }
            p:hover{
              cursor: pointer;
            }
            a {
              text-decoration: none;
              color: inherit;
            }
            a:focus-visible{
              outline: 2px solid #1890ff;
              outline-offset: 2px;
            }
          }
        }
        .right{
          h3{
            margin-top: 20px;
            flex-grow: 0;
            font-family: Poppins-Bold;
            font-size: 24px;
            // font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: normal;
            text-align: left;
            color: #062440;;
          }
          .btn{
            display: flex;
            // margin-top: 30px;
            margin: 30px 0 60px 0;
            .btnA{
              width: 175px;
              height: 42px;
              flex-grow: 0;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              // gap: 10px;
              // padding: 10px 16px;
              border-radius: 5px;
              background-color: #1890ff;
              margin-right: 20px;
              img{
                // margin-top:10px;
                width: 24px;
                height: 24px;
              }
            }
            .IDbtnA{
              width: 212px;
            }
            .btnA:hover{
              background-color:#096dd9;
            }
            .btnA:active{
              background-color: #0757ae;
            }
            .btnB{
              width: 134px;
              height: 26px;
              flex-grow: 0;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              // gap: 10px;
              padding: 8px 16px;
              border-radius: 5px;
              border: solid 1px #fff;
            }
          }
          .icons{
            display: flex;
            margin-top: 20px;
            img{
              width: 24px;
              height: 24px;
              margin:10px 28px 10px 0px;
            }
          }
        }
        .text{
          // width: 112px;
          // height: 22px;
          flex-grow: 0;
          font-family: Poppins-Bold;
          font-size: 16px;
          // font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.38;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          display: flex;
        }
      }
    }
    .secondLine{
      border-top: 1px solid #E5E6EB;
      background-color: #FFFFFF;
      width:100vw;
      height: 100%;
      display: inline-block;
      text-align: center;
      .footBottom{
        margin: auto;
        width: 1210px;
        // padding: 19.4px 630px 25.6px 608px;
        // background-color: #04192d;
        display: inline-flex;
        vertical-align: centre;
        .middle{
          padding:20.1px 0 21.1px 10px;
          display: flex;
          display: inline-flex;
          vertical-align: centre;
          .icon1{
            width: 158.89px;
            height: 49px;
          }
          p{
            // width: 130px;
            height: 20px;
            flex-grow: 0;
            font-family: Poppins;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #67788C;
            padding:10px;
            margin-top: 7px;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .arrow{
    width: 22px;
    height: 22px;
    margin-left: 10px;
  }
  p:hover{
    cursor: pointer;
  }
  .middle a {
    text-decoration: none;
    color: inherit;
  }
  .middle a:focus-visible {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
  }


  .ImgSpace{
    height: 24px;
    width:24px;
    margin:0 !important;
  }
  
  

  .selectStyle{
    width: 62px;
    // min-height: 44px !important;
    
    // >>> input{
    //   border:none;
    // }
    // border:none !important;
  }

  .countryOptions{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding-top: 5px;
    gap:8px;
  }
  .countryOptionsText{
    font-family: 'Poppins-bold';
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.012em;
    color: #314455;
  }

  .countryImg{
    height:24px;
    width:24px;
  }
  .countryImgOutSide{
    height:24px;
    width:24px;
    padding-top: 8px;
  }

@media screen and ( max-width: 1200px ){ 
  .footer {
    text-align: left;
  }
  .firstLine{
    width: auto !important;
    margin: auto 20px !important;
    .footerTop {      
      width: auto !important;
      margin: auto 20px !important;
      display: flex;
      flex-direction: column;
      .col {
        width: fit-content !important;
        min-width: 200px;
      }
    }
  }
  .secondLine {
    text-align: left !important;
    .footBottom {
      width: auto !important;
      margin: auto 20px !important;
    }
  }
}
@media screen and ( max-width: 768px ) { 
  .left {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}

</style>


<style lang="scss">

.selectStyle{
  width: 99px;
  .el-input__inner{
    border:none;
    font-family: 'Poppins-bold';
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.012em;
    color: #314455;
    padding-left:8px;
    padding-right:30px;
  }

  .el-input__icon{
    color: #314455 !important;
    font-weight:700;
  }

}
</style>
